import React from 'react';

import { useAppSelector } from '../../../../redux/store/hooks';
import QuestionsOverView from '../../../ReUsableComponents/QuestionsOverView';

type TestFooterProps = {
  hadleQuestionJump: (number: number) => void;
  questionNumber: number;
  isProgrammingQuestion: boolean;
  isProgrammingTest?: boolean;
  isLoading?: boolean;
  examName: string;
  shouldShowTimer: boolean;
  questionsLength?: number;
};

const TestFooter = ({
  hadleQuestionJump,
  questionNumber,
  isProgrammingQuestion,
  isProgrammingTest,
  isLoading,
  examName,
  shouldShowTimer,
  questionsLength
}: TestFooterProps) => {
  const [view, setView] = React.useState(false);
  const popupRef = React.useRef<HTMLDivElement | null>(null);
  const currentSectionName = useAppSelector(
    state => state.root.startFulltest.currentSectionName
  );
  const { answers } = useAppSelector(state => state.root.questions);
  const { studentDetails } = useAppSelector(state => state.root.auth);
  const sectionQuestions = useAppSelector(
    state => state.root.questions.written
  );
  React.useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node)
      ) {
        setView(false);
      }
    }

    if (view) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [view]);
  return (
    <div
      style={{
        width: '100%'
      }}
      className='flex items-center justify-between bg-[#FFFFFF] px-3 text-black md:px-11'
    >
      <div
        className={`${!shouldShowTimer ? 'justify-between md:w-[33%]' : ' justify-center md:w-[100%]'} hidden items-center md:flex `}
      >
        <div className='max-w-[200px] truncate text-base md:text-xl'>
          {examName}
        </div>
      </div>
      <div ref={popupRef} className='flex-1 md:flex-none'>
        {isProgrammingQuestion && !isProgrammingTest && !shouldShowTimer && (
          <p className='flex w-fit items-center justify-center gap-2 rounded-md border border-[#e4e4e4] bg-primary px-2 py-1 text-sm text-white md:w-full md:px-4 md:py-2 md:text-base'>
            Question {questionNumber + 1} of {sectionQuestions.length}
          </p>
        )}

        {!isProgrammingQuestion && !shouldShowTimer && (
          <>
            <button
              className='flex w-fit items-center justify-center gap-2 rounded-md border border-[#e4e4e4] bg-primary px-2 py-1 text-sm text-[#FFFFFF] md:w-full md:px-4 md:py-2 md:text-base'
              onClick={() => setView(prev => !prev)}
              disabled={isProgrammingQuestion}
            >
              Question {questionNumber + 1} of{' '}
              {questionsLength ?? sectionQuestions?.length}
            </button>
            {view && (
              <div className='absolute bottom-16 left-0 mx-2 flex w-[95%] flex-col rounded-lg border-2 border-delta bg-gamma text-center text-blue_a12 shadow-boxShadowOne md:bottom-28 md:left-[35%] md:mx-0 md:w-[30%]'>
                <div className='my-2 text-sm md:text-base'>
                  {currentSectionName}
                </div>
                <QuestionsOverView
                  questionsList={sectionQuestions}
                  userAnswers={answers}
                  count={questionNumber}
                  navigation={true}
                  strikedOutOptions={[]}
                  hadleQuestionJump={hadleQuestionJump}
                />
              </div>
            )}
          </>
        )}
      </div>

      {!shouldShowTimer && (
        <div className='flex w-[50%] items-center justify-end md:w-[33%]'>
          {currentSectionName}
        </div>
      )}
    </div>
  );
};

export default TestFooter;
